module.exports = __webpack_public_path__ + "static/chit-chats-logo-47c7d7dcaa6a44684514aae457979188.png";